import { render, staticRenderFns } from "./ModuleEditor.vue?vue&type=template&id=0d5ab10d&scoped=true&"
import script from "./ModuleEditor.vue?vue&type=script&lang=js&"
export * from "./ModuleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEditor.vue?vue&type=style&index=0&id=0d5ab10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ab10d",
  null
  
)

export default component.exports